// SPDX-License-Identifier: AGPL-3.0-or-later

import Accessibility from '@app/features/accessibility/state/Accessibility';

// The business iframe consumes the same semantic values as native Fluxer controls.
export const DAOI_THEME_TOKENS = [
	'--background-primary',
	'--background-secondary',
	'--background-secondary-alt',
	'--background-secondary-lighter',
	'--background-tertiary',
	'--background-header-secondary',
	'--background-modifier-hover',
	'--background-modifier-selected',
	'--background-modifier-accent',
	'--background-modifier-accent-focus',
	'--text-primary',
	'--text-primary-muted',
	'--text-secondary',
	'--text-tertiary',
	'--brand-primary',
	'--brand-secondary',
	'--brand-primary-pressed',
	'--brand-primary-fill',
	'--brand-primary-light',
	'--brand-primary-foreground',
	'--button-secondary-text',
	'--button-ghost-text',
	'--form-surface-background',
	'--status-online',
	'--status-danger',
	'--status-warning',
	'--modal-background',
	'--modal-footer-background',
	'--modal-border',
	'--modal-overlay-background',
] as const;

export function getDaoIThemeSnapshot() {
	const root = getComputedStyle(document.documentElement);
	return {
		tokens: Object.fromEntries(DAOI_THEME_TOKENS.map((name) => [name, root.getPropertyValue(name).trim()])),
		fontFamily: root.getPropertyValue('--font-sans').trim() || getComputedStyle(document.body).fontFamily,
		fontMono: root.getPropertyValue('--font-mono').trim(),
		fontSize: root.fontSize,
		reducedMotion: Accessibility.useReducedMotion,
	};
}
